import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';

// Create
export const createBudgetExpense = createAsyncThunk(
    'budgetExpenses/create',
    async (data: FormData, { rejectWithValue }) => {
        try {
            const res = await payrollServiceApiInstance.post('/budget-expenses', data, {
                headers: {
                    'Content-Type': 'multipart/form-data' 
                },
            });
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create expense');
        }
    }
);


// Get All
export const fetchAllBudgetExpenses = createAsyncThunk(
    'budgetExpenses/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const res = await payrollServiceApiInstance.get('/budget-expenses');
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch expenses');
        }
    }
);

// Get By ID
export const fetchBudgetExpenseById = createAsyncThunk(
    'budgetExpenses/fetchById',
    async (id: number, { rejectWithValue }) => {
        try {
            const res = await payrollServiceApiInstance.get(`/budget-expenses/${id}`);
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch expense');
        }
    }
);

// Update
export const updateBudgetExpense = createAsyncThunk(
    'budgetExpenses/update',
    async ({ id, data }: { id: number; data: FormData }, { rejectWithValue }) => {
      try {
        const updatedData: any = {}; // Create an object to store the data
        data.forEach((value, key) => {
          updatedData[key] = value;
        });
        const res = await payrollServiceApiInstance.put(`/budget-expenses/${id}`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return res.data; // Return the updated data
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to update expense');
      }
    }
  );
// Delete
export const deleteBudgetExpense = createAsyncThunk(
    'budgetExpenses/delete',
    async (id: number, { rejectWithValue }) => {
        try {
            await payrollServiceApiInstance.delete(`/budget-expenses/${id}`);
            return id;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete expense');
        }
    }
);
